//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  props: {
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "radio"
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const handleChange = value => {
      emit("change", value);
    };
    return {
      handleChange
    };
  }
});